// Primary colors
export const tangaroa = '#002840';
export const prussianBlue = '#003250';
export const bluemine = '#335B73';

// Accent colors
export const rajah = '#F6B569';
export const cheokee = '#F8C487';
export const tequila = '#F9D09F';

// Semantic colors
export const yellow1 = '#CAA346';
export const yellow2 = '#CEB67C';
export const yellow3 = '#EFE3C5';
export const blue1 = '#0084F4';
export const blue2 = '#66B5F8';
export const blue3 = '#D5E9FA';
export const orange1 = '#FFA26B';
export const orange2 = '#FFC7A6';
export const orange3 = '#FFE8DA';
export const green1 = '#00C48C';
export const green2 = '#7DDFC3';
export const green3 = '#D5F2EA';
export const red1 = '#FF647C';
export const red2 = '#FDAFBB';
export const red3 = '#FBE4E8';

// Neutral colors
export const blackDl = '#111618';
export const grey = '#C9CCD6';
export const grey5 = '#F7F5F9';
export const darkBackground = '#111618B2';
export const darkOrange50 = '#271D124D';
export const lightOrange30 = '#FFF3E54D';

// gradients
export const gradient2 = 'linear-gradient(85.4deg, #F9D09F -12.69%, #F6B569 108.16%) 1';